import { useContext } from "react";
import { AppContext } from "../../context/AppContext";
import { Lock, Unlock } from "react-bootstrap-icons";

function WidthHeightProportionalScale() {
  const {
    isWidthHeightProportionalScaled,
    setIsWidthHeightProportionalScaled,
  } = useContext(AppContext);

  return (
    <button
      className={`
        group relative h-9 w-9 rounded-lg px-2 py-1 transition-all duration-200
        ${
          isWidthHeightProportionalScaled
            ? "bg-slate-500 text-white shadow-sm hover:bg-slate-600"
            : "bg-slate-100 text-slate-600 hover:bg-slate-200 hover:text-slate-700"
        }
      `}
      onClick={() => {
        setIsWidthHeightProportionalScaled((prevState: boolean) => !prevState);
      }}
      title={
        isWidthHeightProportionalScaled
          ? "Proportional scaling enabled - dimensions will scale together"
          : "Proportional scaling disabled - dimensions scale independently"
      }
    >
      <div className="flex items-center justify-center">
        {isWidthHeightProportionalScaled ? (
          <Lock className="h-4 w-4" />
        ) : (
          <Unlock className="h-4 w-4" />
        )}
      </div>
    </button>
  );
}

export default WidthHeightProportionalScale;
